import React from 'react';
import {Box, Typography} from '@mui/material';

import SessionContentChip from '../common/SessionContentChip';

const boxStyle = {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '-0.5rem'
};

const labelStyle = {
    fontSize: '0.875rem',
    marginLeft: '-0.8rem'
};

const RenderServiceTypeWithContentCell = (params) => {
  const DEFAULT_VALUE_WITH_NO_SERVICE = '-';
  const service = params.row.service || DEFAULT_VALUE_WITH_NO_SERVICE;
  const content = params.row.contents || [];

  return (
    <Box sx={boxStyle}>
      <SessionContentChip content={content} />
      <Typography variant="body2" sx={labelStyle}>
        {service}
      </Typography>
    </Box>
  );
};

export default RenderServiceTypeWithContentCell;